import { getAuthToken } from '../cookie-utils';

const getAccessToken = () => {
  const token = getAuthToken();
  return token ? `Bearer ${token}` : null;
};

export default getAccessToken;
